import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdmin } from '../../shared/context/AdminContext';
import { LoadingSpinner } from '../../admin/components/Spinner/Spinner';
import * as primitives from '../../../styles/system/primitives.css';

export interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  redirectTo = '/admin/login'
}) => {
  const { isAuthenticated, isLoading } = useAdmin();
  const location = useLocation();

  // Afficher le spinner pendant le loading
  if (isLoading) {
    return (
      <div className={primitives.screenCenter}>
        <LoadingSpinner size="large" />
        <p>Vérification de l'authentification...</p>
      </div>
    );
  }

  // Redirection si non authentifié
  if (!isAuthenticated) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
